var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isChatGPTPage)?_c('div',{staticClass:"rightside",style:(_vm.isShow)},[_c('i',{staticClass:"iconfont rightside-icon-up mdi mdi-arrow-up",on:{"click":_vm.backTop}}),_c('i',{staticClass:"iconfont rightside-icon-down mdi mdi-arrow-down",on:{"click":_vm.backBottom}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }